import React from 'react';
import Link from '@/components/buttons/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSelector } from 'react-redux';
import { sampleSetDataCurrentSelector, sampleSetDataDataSelector } from '@/redux/selectors/sampleSetData.selector.js';
import { useBiovizStatus } from '../../lenses/uilenses/hooks/biovizStatus/biovizStatus.hook.js';
import { navigateToIBP } from '@/utils/auth0Token';

export const BinfButton = ({ ...props }) => {
  const sampleSetData = useSelector(sampleSetDataDataSelector);
  const current = useSelector(sampleSetDataCurrentSelector);
  const projectId = sampleSetData[current]?.projectId;
	const {status: biovizStatus, href} = useBiovizStatus(projectId);
  
  if (!biovizStatus) return null;

  return (
    <Link onClick={() => navigateToIBP(href)} underline="none" {...props} >BioInformatics {<OpenInNewIcon color="white" viewBox={"0 0 30 30"} />}</Link>);
};

export default BinfButton;